import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.countryWithCode.itemsLoading;
export const getItemsSelect = (state:RootState) => state.countryWithCode.dropDownItems;